import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "28.571",
      height: "20",
      fill: "#006fcf",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m5.437 7.143-2.58 5.709h3.088l.383-.911h.875l.383.91h3.4v-.694l.303.695h1.758l.303-.71v.71h7.07l.859-.887.805.887 3.63.007-2.587-2.846 2.587-2.87H22.14l-.837.87-.78-.87h-7.69l-.662 1.474-.676-1.474H8.413v.671l-.343-.671H5.435zm.597.81h1.505l1.71 3.872V7.953h1.65l1.322 2.776 1.217-2.776h1.641v4.096h-.998l-.008-3.21-1.456 3.21h-.892L10.26 8.84v3.21H8.207l-.39-.918H5.713l-.388.917h-1.1zm9.959 0h4.06l1.241 1.341 1.282-1.34h1.242l-1.887 2.057 1.887 2.036H22.52l-1.242-1.357-1.289 1.357h-3.996zm-9.228.693-.693 1.636h1.385zm10.23.155v.748h2.214v.833h-2.215v.817h2.484l1.154-1.203L19.526 8.8h-2.533z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "american-express"}) } }